import { NavigationItem } from "./NavigationItem";
import { ControllerRegistry } from "../../Registry/ControllerRegistry";
import { AppInfoItem } from "../../HTML/Navigation/AppInfoItem";
import { Menu } from "../../Entity/Menu";
import { toMap, getWebPageService } from "../../../../HA";

export class AppInfo extends NavigationItem {
    /**
     * @param data
     */
    public updateInfo(data: Map<any, any>) {
        let tag = this.getTag().findByAttribute("nav-app-name");
        if (tag && data.get("appName")) {
            tag.setText(data.get("appName"));
        }
        tag = this.getTag().findByAttribute("nav-app-title");
        if (tag && data.get("appTitle")) {
            tag.setText(data.get("appTitle"));
        }
        tag = this.getTag().findByAttribute("nav-app-icon");
        if (tag && data.get("appIcon")) {
            tag.setAttribute("src", data.get("appIcon"));
        }
    }

    /**
     *
     * @param quickMenus
     */
    public updateQmenu(quickMenus: Map<any, any>) {
        const app: Menu = this.get("menuApp");
        if (app) {
            app.clear();
            app.addItem(toMap({
                id: "main",
                l: {classes: ["las", "la-hand-point-left"], _tn: "i", t: "t"},
                n: "Revenir",
                t: "showApp",
            }) as Map<string, any>);
            quickMenus.forEach((qm: any) => {
                const quickMenu: Map<string, any> = toMap(qm) as Map<string, any>;

                app.addItem(toMap({
                    id: quickMenu.get("id"),
                    t: quickMenu.get("t"),
                    n: quickMenu.get("n"),
                    l: quickMenu.get("l"),
                }) as Map<string, any>);
            });
        }

    }

    protected subscribeToAppInfo() {
        this.getAppManager().subscribe("appInfo", (data: Map<any, any>) => {
            this.updateInfo(data);
        });
        this.getAppManager().subscribe("qmenu", (data: Map<any, any>) => {
            this.updateQmenu(data);
        });
    }

    /**
     *
     * @returns AppManager
     */
    protected getAppManager() {
        return this.getService("ha.service.appManager");
    }

    /**
     * @param data
     */
    protected initialize(data: Map<any, any>) {
        super.initialize(data);
        this.subscribeToAppInfo();
        const app = new Menu(toMap({
            animation: this.get("animation"),
            services: this.getServiceManager(),
        }));
        app.addItem(toMap({id: "main", t: "showApp", n: "Revenir"}) as Map<string, any>);
        this.addToData("menuApp", app);

        app.setId("app.main.menu");

        getWebPageService().setQMenu(() => { this.click();});
    }

    protected createTag(data: any) {
        this.addToData("tag", new AppInfoItem(data));
    }

    protected click() {
        const timer = setTimeout(() => {
            if (!this.get("preventDClick")) {
                const app2: Menu = this.get("menuApp");
                getWebPageService().toggleApp(toMap({id: app2.getId(), app: app2}));
            }
            this.addToData("preventDClick", false);
        }, 200);

        this.addToData("dclicktimer", timer);

    }

}

ControllerRegistry.register("AppInfo", AppInfo);
